/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateTagDto } from '../../models/create-tag-dto';
import { TagDto } from '../../models/tag-dto';

export interface TagControllerCreate$Params {
      body: CreateTagDto
}

export function tagControllerCreate(http: HttpClient, rootUrl: string, params: TagControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<TagDto>> {
  const rb = new RequestBuilder(rootUrl, tagControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagDto>;
    })
  );
}

tagControllerCreate.PATH = '/api/tags';
